import React, { JSX } from "react";
import { Alert, AlertTitle, IconButton } from "@mui/material";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useHistory } from "react-router-dom";

/**
 * The `EditUserInfoAlert` component displays an alert message
 * indicating that the user can make edits to the team member details under the client's profile page.
 * @component
 * @param {string | number} clientId - The ID of the client.
 * @returns {JSX.Element} The `EditUserInfoAlert` component.
 */
const EditUserInfoAlert = ({ clientId }: { clientId: string | number }): JSX.Element => {
  const history = useHistory();

  return (
    <Alert
      severity="info"
      action={
        <IconButton
          onClick={() => history.push(`/clients/${clientId}/care-team`)}
        >
          <ArrowUpRight weight="regular" />
        </IconButton>
      }
    >
      <AlertTitle>Looking to make edits?</AlertTitle>
      Changes to team member details can be made under the Client&apos;s care team page.
    </Alert>
  );
};

export default EditUserInfoAlert;
